import { Deal } from '@/models/registry';
import { observer } from 'mobx-react-lite';
import { useMemo } from 'react';
import AuditTrail from './audit-trail';
import { getCombinedAuditLogs } from './combined-audit-line';
import AddCommentTiptap from './tip-tap-editor/add-comment-tiptap';
type OrderBy = 'newest' | 'oldest';

const ActivityFeed = observer(
  ({ deal, orderBy }: { deal: Deal; orderBy: OrderBy }) => {
    const auditLog = deal.audit_log;
    const comments = deal.comments;
    const sortedAuditLogs = useMemo(() => {
      /* The auditLogs come in chronological order, so we need to reverse them if the orderBy is "oldest" */

      if (orderBy === 'newest') {
        // reverse the auditLogs
        const reversedAuditLogs = [...auditLog].reverse();
        return reversedAuditLogs;
      }

      return auditLog;
    }, [auditLog, orderBy]);

    const sortedLogsWithGroupedAudits = useMemo(() => {
      return getCombinedAuditLogs(sortedAuditLogs, deal.audits);
    }, [sortedAuditLogs, deal.audits]);

    if (orderBy === 'newest') {
      return (
        <div className="flex flex-col gap-4">
          <AddCommentTiptap dealId={deal.id} />
          <AuditTrail
            auditLogs={sortedLogsWithGroupedAudits}
            audits={deal.audits}
            comments={comments}
            dealId={deal.id}
          />
        </div>
      );
    }

    return (
      <div className="flex flex-col gap-4">
        <AuditTrail
          key={orderBy}
          auditLogs={sortedLogsWithGroupedAudits}
          audits={deal.audits}
          comments={comments}
          dealId={deal.id}
        />

        <AddCommentTiptap dealId={deal.id} />
      </div>
    );
  },
);

export default ActivityFeed;
